import SchemaMarkup from "../Components/SchemaMarkup";

const ContactPageSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",

    "@id": "https://msayurved.com/contact/#contactpage",

    "url": "https://msayurved.com/contact/",

    "name": "Contact Dr. Jigar Gor's Ayurveda",

    "description":
      "Contact Dr. Jigar Gor's Ayurveda Center in Bhuj, Kutch, Gujarat for Ayurvedic consultations, treatment information, and healthcare inquiries.",

    "isPartOf": {
      "@id": "https://msayurved.com/#website"
    },

    "about": {
      "@id": "https://msayurved.com/#medicalclinic"
    },

    "mainEntity": {
      "@id": "https://msayurved.com/#medicalclinic"
    },

    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default ContactPageSchema;